var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"crumbs"},[_c('ul',{staticClass:"crumbs_ul"},_vm._l((_vm.config),function(item){return _c('li',{key:item.url},[(item.url)?_c('a',{attrs:{"href":item.url}},[_vm._v(_vm._s(item.text))]):_c('span',[_vm._v(_vm._s(item.text))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }